<app-header></app-header>

<div class="container-fluid" style="width: 80%; min-height: 600px">

    <div class="row mt-4 mb-4">
        <div class="col">
            <nav class="breadcrumb-container" aria-label="Percorso di navigazione">
                <ol class="breadcrumb mb-0 p-0">
                    <li class="breadcrumb-item"><a routerLink="/home">Home</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item"><a routerLink="/home">Admin</a><span class="separator">/</span></li>
                    <li class="breadcrumb-item active" aria-current="page">Comuni</li>
                </ol>
            </nav>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col">
            <h4>Amministrazione – Comuni</h4>
        </div>
    </div>

    <mat-card class="p-2" appearance="outlined">
        <mat-card-content>
            @if (caricamento && comuni.length === 0) {
                <div class="text-center py-4">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p class="mt-2 mb-0">Caricamento comuni...</p>
                </div>
            } @else if (errore && comuni.length === 0) {
                <p class="text-danger">{{ errore }}</p>
            } @else {
                <p class="mb-3"><b>Elenco comuni</b> ({{ totalElements }} totali, pagina {{ pageIndex + 1 }} di {{ totalPages }})</p>
                <mat-form-field class="w-100 mb-2">
                    <mat-label>Cerca comuni</mat-label>
                    <input matInput (keyup)="onSearchInput($event)" placeholder="Codice ISTAT, nome, provincia, regione" #searchInput>
                </mat-form-field>
                @if (caricamento && comuni.length > 0) {
                    <div class="text-center py-2">
                        <mat-spinner diameter="32"></mat-spinner>
                    </div>
                }
                <table mat-table [dataSource]="comuni" class="w-100">
                    <ng-container matColumnDef="istatCode">
                        <th mat-header-cell *matHeaderCellDef>Cod. ISTAT</th>
                        <td mat-cell *matCellDef="let c">{{ c.istatCode }}</td>
                    </ng-container>
                    <ng-container matColumnDef="nome">
                        <th mat-header-cell *matHeaderCellDef>Nome</th>
                        <td mat-cell *matCellDef="let c">{{ c.nome }}</td>
                    </ng-container>
                    <ng-container matColumnDef="provinciaSigla">
                        <th mat-header-cell *matHeaderCellDef>Provincia</th>
                        <td mat-cell *matCellDef="let c">{{ c.provinciaSigla }}</td>
                    </ng-container>
                    <ng-container matColumnDef="regioneNome">
                        <th mat-header-cell *matHeaderCellDef>Regione</th>
                        <td mat-cell *matCellDef="let c">{{ c.regioneNome }}</td>
                    </ng-container>
                    <ng-container matColumnDef="validFrom">
                        <th mat-header-cell *matHeaderCellDef>Valido da</th>
                        <td mat-cell *matCellDef="let c">{{ c.validFrom }}</td>
                    </ng-container>
                    <ng-container matColumnDef="validTo">
                        <th mat-header-cell *matHeaderCellDef>Valido a</th>
                        <td mat-cell *matCellDef="let c">{{ c.validTo }}</td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                            Nessun comune trovato.
                        </td>
                    </tr>
                </table>
                <mat-paginator [length]="totalElements" [pageIndex]="pageIndex" [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions" (page)="onPage($event)" showFirstLastButtons
                    aria-label="Seleziona pagina comuni">
                </mat-paginator>
            }
        </mat-card-content>
    </mat-card>

</div>

<app-footer></app-footer>
